import { render } from "./narvar2_ingles.vue?vue&type=template&id=cc3f2202&scoped=true"
import script from "./narvar2_ingles.vue?vue&type=script&lang=js"
export * from "./narvar2_ingles.vue?vue&type=script&lang=js"

import "./narvar2_ingles.vue?vue&type=style&index=0&id=cc3f2202&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc3f2202"]])

export default __exports__